import { FiltersProvider } from "../../../contexts/FiltersContext"
import PackagesListView from "./PackagesListView"

const PackageListPage = () => {
  return (
    <FiltersProvider>
      <PackagesListView />
    </FiltersProvider>
  )
}

export default PackageListPage
